import ScrollToTop from "react-scroll-to-top";


function Scroll_To_top() {
    
    return (
        <ScrollToTop smooth top="300" className="Scroll_To_top" color="#78f701"/>
    )
}
export default Scroll_To_top;